/**
 * @file Email verification notice and resending component.
 */

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import Alert from '../global/Alert';
import Button from '../global/Button';
import { getErrorString } from '../../util/normalize-errors';
import { getAsset } from '../../util/assets';

class EmailVerificationNotice extends Component {
  static propTypes = {
    requestEmailVerification: PropTypes.func.isRequired,
    user: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
    redirectUrl: PropTypes.string,
  };

  state = {
    emailSent: false,
    error: '',
  };

  onResendEmailVerification = async () => {
    const { requestEmailVerification, user, redirectUrl } = this.props;

    this.setState(() => ({ emailSent: false }));

    try {
      await requestEmailVerification(user.id, redirectUrl);
      this.setState(() => ({ emailSent: true }));
    } catch (error) {
      this.setState(() => ({
        emailSent: false,
        error: getErrorString(error),
      }));
    }
  };

  render() {
    const { emailSent, error } = this.state;

    return (
      <Fragment>
        <div className="text-center mb-3">
          <img src={getAsset('/waldo-icon.svg')} alt="" width="70px" />
        </div>

        <Alert type="note">
          Please verify your email by clicking the link we&rsquo;ve sent you
          when you signed up.
        </Alert>

        <div className="text-sm text-center">
          Haven&rsquo;t received or lost the email? No worries!
          <br />
          <Button btnStyle="link" onClick={this.onResendEmailVerification}>
            Click here and we&rsquo;ll send you another.
          </Button>
        </div>

        {error && (
          <Alert type="danger" className="mt-2">
            {error}
          </Alert>
        )}

        {emailSent && (
          <Alert type="success" className="mt-2">
            Email sent successfully! Please check your inbox.
          </Alert>
        )}
      </Fragment>
    );
  }
}

export default EmailVerificationNotice;
